<template>
  <div
    class="d-flex-column justify-start align-start gap-0 booster_profile_game_card"
  >
    <div class="d-flex-row space-between top_area">
      <div class="d-flex-row justify-start flex-5">
        <img
          :src="image"
          alt="Game icon"
          height="36"
          width="36"
          style="border-radius: 5px"
        />
        <h4 class="t-white bold-xl font-family-2 white-space-no">
          {{ $t(`${gameTitle}.short_title`) }}
        </h4>
      </div>
      <div class="d-flex-row justify-end flex-5" v-if="isPrimary">
        <p class="t-grey font-family-2 caps regular-s f-w-700 primary_game">
          {{ $t("dashboard.primary_game") }}
        </p>
      </div>
    </div>
    <div class="d-flex-row space-between bottom_area gap-30 md-row-to-col">
      <div class="d-flex-row flex-4 left_area gap-18" v-if="rank">
        <img
          :src="rank?.image_dark"
          alt="Game rank image"
          class="rank_image"
          v-if="rank?.image_dark"
        />
        <div class="d-flex-column justify-start align-start gap-0 flex-2">
          <label class="caps medium-s t-light font-family-2">{{
            $t("booster_profile.rank")
          }}</label>
          <h4 class="t-white bold-xxxl font-family-2 white-space-no">
            {{ rank.title }}
          </h4>
        </div>
      </div>

      <div class="d-flex-column flex-6 right-area md-row-to-col">
        <div
          class="d-flex-row space-between game_detail_info"
          v-if="showHeroes"
        >
          <div class="d-flex-row justify-start flex-3">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.25 4.57101C13.1054 2.32911 11.7647 1.48535 9.14094 0.600098C6.51716 1.48535 5.17646 2.32911 3.03192 4.57101C3.59739 8.47194 3.22322 10.1647 1.19922 12.2074C2.88304 14.7217 3.99503 15.7724 6.08643 17.4001C5.37889 14.8631 5.30448 13.4009 6.08643 10.6801C4.32707 9.32458 4.072 8.42798 4.25373 6.70919C7.71391 7.81438 8.24052 8.82807 7.91913 10.9856L9.14094 13.1237L10.3627 10.9856C10.0414 8.82807 10.568 7.81438 14.0281 6.70919C14.2099 8.42798 13.9548 9.32458 12.1954 10.6801C12.9774 13.4009 12.903 14.8631 12.1954 17.4001C14.2868 15.7724 15.3988 14.7217 17.0827 12.2074C15.0587 10.1647 14.6845 8.47194 15.25 4.57101Z"
                fill="#9A9A9A"
              />
            </svg>
            <label class="t-white medium-l white-space-no font-family-2">{{
              $t(`order.card.${gameTitle}.legends_preferences`)
            }}</label>
          </div>
          <div class="d-flex-row justify-end">
            <div
              class="white-space-no regular-l t-light font-family-2"
              v-for="hero in [...heroes].splice(0, 3)"
              :key="hero"
            >
              {{ hero.title }}
            </div>
            <div
              class="white-space-no regular-l t-light font-family-2"
              v-if="heroes.length > 3"
            >
              +{{ heroes.length - 3 }}
            </div>
          </div>
        </div>

        <div class="d-flex-row space-between game_detail_info" v-if="showRoles">
          <div class="d-flex-row justify-start flex-3">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.4389 15.4409C16.4172 15.9826 15.9831 16.4168 15.4413 16.4385L3.40055 16.9201L12.6049 13.5291C13.0336 13.3712 13.3715 13.0333 13.5295 12.6046L16.9205 3.40058L16.4389 15.4409Z"
                fill="#9A9A9A"
              />
              <path
                d="M1.80194 2.79951C1.82361 2.25779 2.25781 1.82359 2.79953 1.80193L14.8403 1.32031L5.63591 4.71129C5.20724 4.86922 4.86934 5.20711 4.7114 5.63578L1.32031 14.8398L1.80194 2.79951Z"
                fill="#9A9A9A"
              />
              <path
                d="M6.52003 8.32015C6.52003 7.32604 7.32592 6.52015 8.32003 6.52015H9.92003C10.9141 6.52015 11.72 7.32604 11.72 8.32015V9.91997C11.72 10.9141 10.9141 11.72 9.92003 11.72H8.32003C7.32591 11.72 6.52003 10.9141 6.52003 9.91997V8.32015Z"
                fill="#9A9A9A"
              />
            </svg>

            <label class="t-white medium-l font-family-2">{{
              $t("booster_profile.roles")
            }}</label>
          </div>
          <div class="d-flex-row justify-end">
            <div
              class="white-space-no regular-l t-light font-family-2"
              v-for="role in [...roles].splice(0, 3)"
              :key="role"
            >
              {{ role.title }}
            </div>
            <div
              class="white-space-no regular-l t-light font-family-2"
              v-if="roles.length > 3"
            >
              +{{ roles.length - 3 }}
            </div>
          </div>
        </div>

        <div
          class="d-flex-row space-between game_detail_info"
        >
          <div class="d-flex-row justify-start flex-3">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.7398 6.34173C14.9622 2.90592 12.0192 1.20215 9.13028 1.2002C6.24134 1.19824 3.29625 2.89811 2.51467 6.33389L2.51454 6.33445C1.61265 10.3185 4.09906 13.6349 6.12952 15.5918L6.13021 15.5925C7.80624 17.2022 10.4474 17.2036 12.1176 15.5919C14.1554 13.6348 16.6417 10.3258 15.7398 6.34173ZM6.31832 7.7758C6.31832 6.22463 7.57579 4.96715 9.12696 4.96715C10.6781 4.96715 11.9356 6.22463 11.9356 7.7758C11.9356 9.32698 10.6781 10.5845 9.12696 10.5845C7.57579 10.5845 6.31832 9.32698 6.31832 7.7758Z"
                fill="#9A9A9A"
              />
            </svg>

            <label class="t-white medium-l font-family-2">{{
              $t("booster_profile.regions")
            }}</label>
          </div>

          <div class="d-flex-row justify-end">
            <div
              class="regular-l t-light font-family-2 white-space-no"
              v-for="region in regions"
              :key="region"
            >
              {{ region.title }}
            </div>
            <div
              class="regular-l t-light font-family-2 white-space-no"
              v-if="regions.length > 3"
            >
              +{{ regions.length - 3 }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    image: {
      type: String,
      default: "",
    },
    gameTitle: {
      type: String,
      default: "",
    },
    rank: {
      default: {},
    },
    roles: {
      default: [],
    },
    heroes: {
      default: [],
    },
    regions: {
      default: [],
    },
    isPrimary: {
      default: false,
    },
    gameId: {
      default: 0,
    },
  },

  computed: {
    showHeroes() {
      if ([4, 7, 10, 9, 16, 24, 25, 26].includes(this.gameId)) {
        return false;
      }
      return true;
    },
    showRoles() {
      if ([1, 16].includes(this.gameId)) {
        return true;
      }
      return false;
    },
  },
};
</script>
